import { render, staticRenderFns } from "./AccountReceivable.vue?vue&type=template&id=483cd8ec&scoped=true"
import script from "./AccountReceivable.vue?vue&type=script&lang=js"
export * from "./AccountReceivable.vue?vue&type=script&lang=js"
import style0 from "./AccountReceivable.vue?vue&type=style&index=0&id=483cd8ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483cd8ec",
  null
  
)

export default component.exports